import React from 'react'
import Button from 'material-ui/Button';
import ForwardIcon from 'material-ui-icons/Forward'
import { withStyles } from 'material-ui/styles'

const styles = {
    root: {
        position: `absolute`,
        top: `calc(50% - 4px)`,
        left: `calc(50% - 4px)`,
        transform: `translate(-50%, -50%)`,
        zIndex: 2,
    }
}

const GoButton = (props) => {

    const handleClick = (e) => props.onClick(e)

    return (
        <Button variant="fab"
            color="secondary"
            mini
            disabled={props.disabled}
            classes={{
                root: props.classes.root
            }}
            onClick={handleClick}>
            <ForwardIcon />
        </Button>
    )
}

export default withStyles(styles)(GoButton)


// WEBPACK FOOTER //
// ./src/components/buttons/go.js